// FormView.js

import { View }     from 'backbone';
import _            from 'lodash';
import util         from 'util/Util.js';
import $            from 'jquery';
import Immutable    from 'immutable';
import BaseControlView from 'BaseControlView';
import focusController  from 'FocusController';
import eventBus         from 'EventBus';
import themeService     from 'ThemeService';
import listService      from 'ListService';
import constants        from 'Constants';
import pageInstanceFactory from 'PageInstanceFactory';
import pageSyncService  from 'PageSyncService';
import undoService from 'UndoService';
import textConstants from 'TextConstants';
import utilMobile from '../../mobile/commons/MobileGeneralFunctions';
import pageCollection   from 'PageCollection';
import crudController from '../../controllers/CrudController';

const canvases = '#aPage, #aPageSel';

//==========================================================================================
// A BackBone view of a PerfectForms form page. Has a PageView, that, in turn, has one
// or more PageInstanceViews. Also contains view references for the four major control
// property UIs.
//
// Lou Mauget, December 17, 2015
//==========================================================================================
class FormView extends BaseControlView {

    initialize( opts ) {
        this.options = opts || {};

        if (this.model.get('factoryKey') === 'layout_frame' || this.model.get('factoryKey') === 'reports_frame') {
            super.initialize(opts);
        }

        this.model.set( 'id', this.id, {silent: true});
        this.tagName = 'div';
        this.events = {
            'mousedown': 'onClick'
        };

        // Used to classify clicks heard on this object and also its contained objects.
        this.clickMap = Immutable.Map({
            'designer-form has-menu':                        this._onClickForm,
            // 'page-selection-background pf-control': this._onClickPage,
            'pf-control-core':                      this._onClickControl
        });

        /*
        this._subviews = Immutable.Map()
            .set( 'styleView',      new StyleView(      { model: this.model, el: $(constants.PROP_STYLE_ID) } ))
            .set( 'behaviorView',   new BehaviorView(   { model: this.model, el: $(constants.PROP_BHVR_ID)  } ))
            .set( 'attributesView', new AttributesView( { model: this.model, el: $(constants.PROP_ATTRIBUTES_ID)} ))
            .set( 'settingsView', new TabSettingsView( { model: this.model, el: $(constants.PROP_SETTNGS_ID)} ))
            .set( 'accessView', new TabAccessView( { model: this.model, el: $(constants.PROP_ACCESS_SECTION)} ));
*/

        // Copy over size from desktop if exists, this happens when coming from Behaviors / Workflow mode.
        if (listService.currentForm &&
            ( this.model.get('factoryKey') === 'layout_frame' || this.model.get('factoryKey') === 'reports_frame') ) {
            if (listService.currentForm.model.attributes.deviceDesktop) {
                var width = listService.currentForm.model.attributes.deviceDesktop.formWidth;
                var height = listService.currentForm.model.attributes.deviceDesktop.formHeight;

                if (width) {
                    this.model.set('formWidth', width);
                }
                if (height) {
                    this.model.set('formHeight', height);
                }
            }


        }

        // Record the form among the listService objects.
        //listService.updateObject( constants.FORM_RAW_ID, this );

        // Listen for custom event addPage
        //$( document ).off( constants.EV_ADD_PAGE);
        //$( document ).on( constants.EV_ADD_PAGE, this._addPage );

        $( document ).off( constants.EV_PAGE_DELETE_CURRENT);
        $( document ).on( constants.EV_PAGE_DELETE_CURRENT, this._deleteCurrentPage );


        this.listenTo( eventBus, 'selectForm', this._onClickForm );
        //this.listenTo( eventBus, 'selectPage', this._onClickPage );
        this.listenTo( eventBus, 'outsideColorSet', this.setScreenColor );
        this.listenTo( eventBus, 'mobileOutsideColorSet', this.setMobileScreenColor );
        this.listenTo( eventBus, 'frameWidthSet', this.setFrameWidth );
        this.listenTo( eventBus, 'showFrameSet', this.setShowFrame );
        this.listenTo( eventBus, 'frameColorSet', this.setFrameColor );
        this.listenTo( eventBus, 'roundCornersSet', this.setRoundCorners );

        return this;
    }


    setScreenColor(value) {
        this.model.attributes.outsideColor = value;
        this.render();
    }

    setMobileScreenColor(value) {
        this.model.set('mobileOutsideColor', value, constants.MODEL_SILENT);
        this.render();
    }


    setFrameWidth(value) {
        this.model.attributes.frameSize = value;
    }


    setShowFrame(value) {
        this.model.attributes.frame = value;
    }


    setFrameColor(value) {
        this.model.attributes.frameColor = value;
    }


    setRoundCorners(value) {
        this.model.attributes.frameRoundCorners = value;
    }

    _deleteCurrentPage() {
        const pageId = listService.currentPageId;
        //Retrieve page from collection
        if (pageId !== undefined) {
            const myPage = listService.getPage(pageId); 
            const currentPageIndex = listService.getPageIndex(myPage.id);
            myPage.currentIndex = currentPageIndex;
            const targetBehaviors = listService.getBehaviorInstanceByPage(myPage.id);
            const targetBehaviorsMap = listService.behaviorCommands;
            const targetBehaviorConnectionsMap = listService.behaviorConnections;
            undoService.add({
                undo: () => {
                    // 1. Clear visible controls from the dom
                    pageSyncService.clearCurrentPageView();
                    // 2. Ensure we have canvases. They're hidden if user had deleted last page instance.
                    $(canvases).show();

                    // 3. Reatach behaviors in case they existed                    
                    crudController.restoreBehaviors(targetBehaviors, myPage.id, targetBehaviorsMap, targetBehaviorConnectionsMap);

                    // 4. Add the saved page
                    listService.addPage(myPage.id, myPage, {pageIndex: currentPageIndex, undo:true});

                    // 5. Visually show selection on the thumbnail for the page
                    pageSyncService.selectThumbNail();
                    // 6. Scroll thumbnails to new entry.
                    $(constants.THUMBPANE_ID).scrollTop(Number.MAX_VALUE);
                    pageSyncService.displayPage(listService.currentPageId);
                    eventBus.trigger(constants.EV_VALIDATE_PULSE_ICON_EVENT);
                },
                redo: () => {
                    // 1. Clear visible controls from the dom
                    pageSyncService.clearCurrentPageView();
                    // 2. Remove page from backing store
                    listService.deletePage(pageId);
                    // 3. Visually show selection on the thumbnail for the page
                    pageSyncService.selectThumbNail();
                    // 4. Scroll thumbnails to new entry.
                    $(constants.THUMBPANE_ID).scrollTop(Number.MAX_VALUE);
                    pageSyncService.displayPage(listService.currentPageId);
                    // 5. If no more pages hide the three canvases
                    if (!listService.pageCount) {
                        $(canvases).hide();
                    }
                }
            }, textConstants.UNDO_DELETE);

            // Clear visible controls from the dom
            pageSyncService.clearCurrentPageView( pageId );

            eventBus.trigger( $(constants.EV_PAGE_DELETE_CURRENT) );

            // Remove page from backing store
            console.log(`Gonna remove page ${pageId}`);
            listService.deletePage(pageId);  

            const that = this;
            setTimeout(() => {

                // Visually show selection on the thumbnail for the page
                pageSyncService.selectThumbNail();

                // Scroll thumbnails to new entry.
                $(constants.THUMBPANE_ID).scrollTop(Number.MAX_VALUE);

                pageSyncService.displayPage( listService.currentPageId );

                // If no more pages hide the three canvases
                if (!listService.pageCount){
                    $(canvases).hide();
                    eventBus.trigger('selectForm');
                } else {
                    eventBus.trigger('selectPage');
                }
            },0); 
        } 
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.off();
        
        //super.remove();!!! This is not working, fails to switch between designer and Behaviors
        //$( document ).off( constants.EV_ADD_PAGE, this._addPage );
    }


    _onClickForm( evt ){

        // #PF-1401 Cleaning any column table selection on Page Selection.
        const columnSelectedSelector=$(`#${listService.currentId}`);
        columnSelectedSelector.find('td').removeClass('column-selection');
        columnSelectedSelector.find('th').removeClass('column-selection');
        listService._isSelectedPage = false;
        if (evt) {
            evt.stopPropagation();
        }
        if (_.includes(['L','R', 'M'], listService.mainKind) ) {
            listService.currentId = constants.FORM_RAW_ID;

            const fName = listService.currentForm.model.get("name");
            $('.rail-header-text').text(fName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
            $('.rail-header-text').prop('title', fName + constants.RIGHT_PANEL_PROPERTIES_TITLE);
            eventBus.trigger(constants.EV_UPDATE_BREADCRUMB, 'FORM', listService.currentId);

            setTimeout(()=>{
              focusController.switchPropsViews();
               console.log('MainKind',listService.mainKind);
                util.updateHelpDocumentationLink(listService.mainKind);

                let tabProps = $('#property-tabs a[href="#propStyle"]');
                if (util.isTrue(tabProps.attr('aria-expanded')) && !listService.selected.size) {
                    util.showScrollOnPanel (410, 410);
                }
            },500);
        }
        // Select form on left panel
        $('#thumb-pages .document-heading').removeClass('page-selected');
        $('#tn-pg-aform .document-heading').addClass('page-selected');

    }

    // _onClickPage( evt ){
    //     // This is being handled in PageView.js
    //     /*
    //     console.log('clicked the current page');
    //     if (evt) {
    //         evt.stopPropagation();
    //     }
    //     listService.currentId = listService.currentPageId;
    //     eventBus.trigger('updateBreadCrumb', 'PAGE', listService.currentPageId);
    //
    //     var o = listService.getPage(listService.currentPageId);
    //     console.log(o);
    //
    //     */
    //
    // }

    _onClickControl( evt ){
        console.log('clicked some control');
        // This click already flows to focusController without interference here.
    }

    //==========================================================================================
    // Due to nested clickables, we see clicks of anything on the form here. Identify
    // which of three kinds of clicked item was clicked. We want to tell the focusController
    // that we're a clicked form if nothing we contain was directly clicked.
    //
    // Clicked form:
    //
    //      evt.originalEvent.target.className == 'designer-form'
    //
    // CLicked control:
    //
    //      evt.originalEvent.target.className == 'pf-control-core'
    //
    // Clicked page:
    //
    //      evt.originalEvent.target.className == "page-selection-background pf-control"
    //==========================================================================================
    onClick(evt) {
        // Get and call the correct function for whatever kind of thing was clicked.
        var className = evt.originalEvent ? evt.originalEvent.target.className : evt.target.className;

        const handler = this.clickMap.get(className);
        if (handler) {
            focusController.clearAllSelected();
            util.validateMenuItems(-1);
            (handler)(evt);
        }
    }

    setFrame() {

        const showFrame = this.model.get('frame');
        this.setShowFrame(showFrame);

        const corners = this.model.get('frameRoundCorners');
        this.setRoundCorners(corners);

        const frameColor = this.model.get('frameColor');
        this.setFrameColor(frameColor);

        const frameSize = this.model.get('frameSize');
        this.setFrameWidth(frameSize);

    }

    //==========================================================================
    // Implements standard BackBone View render method.
    // Instead of rendering, we capture any theme item change to its ThemeModel.

    // (The form is rendered by simple template embedding in its parent
    // template.)

    // That model is shared only with the theme property panel (aks 'dialog').
    // When it changes a theme item, we reflect the change to the master
    // theme object.
    //==========================================================================
    render() {        
        // 1. Change the item values in the master theme
        const attrs = this.model.changedAttributes();

        _.forEach( attrs, (value, name) => {
            themeService.theme[name] = value;
        });

        // 2. Notify control views of the changed attributes
        //this.notifyControlViews( attrs );

        if (listService.mainKind === 'L' || listService.mainKind === 'R') {
            //apply page style
            this.setFrame();

            const value = this.model.attributes.outsideColor;
            $('.designer-form').css('background-color', value);
        } else if (listService.mainKind === constants.KIND_MOBILE) {
            const value = this.model.attributes.mobileOutsideColor;
            $('.designer-form').css('background-color', value);
            $('#mobile-columns-container').css('background-color', value);
        }

        this.delegateEvents(); 
 
        if (listService.mainKind !== 'W') {
            setTimeout(() => {  
                // If no more pages hide the three canvases
                if (!listService.pageCount) {
                    $(canvases).hide();
                }
            }, 0); 
        }

        if(listService.mainKind === constants.KIND_MOBILE){
            this.model.set('displayCenterSettings', 'none', constants.MODEL_SILENT);
            this.model.set('displayShadowSettings', 'none', constants.MODEL_SILENT);
        } else {
            // PF-9585 Screen properties are removed from Form Properties after creating a mobile design
            // Revert values to default
            this.model.set('displayCenterSettings', 'block', constants.MODEL_SILENT);
            this.model.set('displayShadowSettings', 'block', constants.MODEL_SILENT);
        }

        let isIExplorer = () => {
            return !!(((false) || (document.documentMode)) || (!(document.documentMode) && window.StyleMedia));
        };
          
        if (isIExplorer()){
            setTimeout(function() { document.getElementById('groupCommon').focus(); }, 0);
        }
        
        return this;
    }

    //==========================================================================
    // Triggers changed attributes event on all control views
    //==========================================================================
    notifyControlViews( attrs ) {
        this.undelegateEvents();

        listService.objectList.map( (id, view) => {
            if (view.delegateEvents) {
                view.delegateEvents('change');
                _.forEach(attrs, (atr) => {
                    view.trigger(`change:[${atr}]`);
                });
                view.undelegateEvents('change');
            }
        });

        this.delegateEvents();
    }

}

export default FormView;
